// removed by extract-text-webpack-plugin
module.exports = {"response":"_1VBLDEYx-kCPJw5fkTRbvh","responsewrap":"_3H4BvyRcT6lAPvnp9Cfo-R","avatarwrap":"_23WsHkL_-F_t_NBya_iaI1"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/CreateComment/style.css
// module id = 516
// module chunks = 38